//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'About',
  head: {
    title: 'Your Best Choice in CE',
    meta: [
      {
        hid: 'og:title',
        name: 'og:title',
        content: 'Your Best Choice in CE',
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content: 'Summit is the national leader is providing continuing education courses for physical therapists, occupational therapists, and speech language pathologists. Whether you are obtaining continuing education for yourself or an entire organization, Summit is unique in how we create outstanding value for your time and money.',
      },
      {
        hid: 'description',
        name: 'description',
        content: 'Summit is the national leader is providing continuing education courses for physical therapists, occupational therapists, and speech language pathologists. Whether you are obtaining continuing education for yourself or an entire organization, Summit is unique in how we create outstanding value for your time and money.',
      },
    ],
  },
  methods: {
    openLinkInNewTab (link) {
      window.open(link, '_blank');
    },
  },
};
